import { Icon } from '@wartek-id/icon-v2'
import { Spinner } from '@wartek-id/spinner'

import CircularProgress from 'app/KinerjaShared/components/CircularProgress'

import type { PropsCircularProgress } from 'app/KinerjaShared/components/CircularProgress'
import type { FC } from 'react'

interface CircularProgressV2Props extends PropsCircularProgress {
  isLoading?: boolean
  isLocked?: boolean
}

const CircularProgressV2: FC<CircularProgressV2Props> = ({
  isLoading = false,
  isLocked = false,
  ...props
}) => {
  if (isLoading) return <Spinner size="lg" />

  if (isLocked)
    return (
      <div
        data-testid="circular-progress-locked"
        className="flex items-center justify-center w-20 h-20 rounded-full bg-gray-30"
      >
        <div className="flex items-center justify-center w-16 h-16 bg-white rounded-full">
          <Icon className="!cursor-not-allowed">lock_outline</Icon>
        </div>
      </div>
    )

  return <CircularProgress {...props} />
}

export default CircularProgressV2
